import React from 'react';
import { SubscriptionLayout } from '../components/SubscriptionLayout';
import { CurrentPlan } from '../components/CurrentPlan';

export const CurrentPlanPage = () => {
  return (
    <SubscriptionLayout activeTab="current-plan">
      <CurrentPlan />
    </SubscriptionLayout>
  );
};
